import Vue from 'vue'
import VueRouter from 'vue-router'
import Debtors from '../views/Debtors.vue';
import Payments from '../views/Payments.vue';
import DebtorView from '../views/DebtorView.vue'
import Warrants from "../views/Warrants.vue"
import WarrantView from '../views/WarrantView.vue'
import Invoices from '../views/Invoices.vue'
import AccountStatements from '../views/AccountStatements.vue'
import AccountStatementView from '../views/AccountStatementView'
import WarrantOpen from '../views/WarrantOpen.vue'
import Settlement from '../views/Settlement.vue'
import ManageTribunal from '../views/ManageTribunal.vue'
import ManageClose from '../views/ManageClose.vue'
import ManageUnused from '../views/ManageUnused.vue'
import ManageWarrantsWithoutSettlements from '../views/ManageWarrantsWithoutSettlements.vue'
import ManageSettlementsInDefault from '../views/ManageSettlementsInDefault.vue'
import ManageWarrants3Reminders from '../views/ManageWarrants3Reminders.vue'
import ManageWarrantsStopped from '../views/ManageWarrantsStopped.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/warrants'
  },
  {
    path: '/warrant/open/:id',
    name: 'warrantOpen',
    component: WarrantOpen,
    props: true
  },
 
  {
    path: '/debtors',
    name: 'debtors',
    component: Debtors
  },
  {
    path: '/debtor/view/:id',
    name: 'debtorView',
    component: DebtorView,
    props: { edit: false }
  },
  
  {
    path: '/debtor/new',
    name: 'debtorNew',
    component: DebtorView,
    props: { _new: true, edit: true }
  },
  {
    path: '/debtors/:search',
    name: 'debtorsSearch',
    component: Debtors
  },
  {
    path: '/payments',
    name: 'payments',
    component: Payments
  },
 
  {
    path: '/invoices',
    name: 'invoices',
    component: Invoices
  },
 
  {
    path: '/settlement/:id',
    name: 'settlement',
    component: Settlement,
    props: true

  },
   {
    path: '/warrant/view/:id',
    name: 'warrantView',
    component: WarrantView,
    props: true
  },
  {
    path: '/warrant/edit/:id',
    name: 'warrantEdit',
    component: WarrantView,
    props: { edit: true }
  },
  {
    path: '/invoices/:search',
    name: 'invoicesSearch',
    component: Invoices
  },
  {
    path: '/warrants/',
    name: 'warrants',
    component: Warrants
  },
 
  {
    path: '/manage-tribunal/',
    name: 'manageTribunal',
    component: ManageTribunal
  },
  {
    path: '/manage-close/',
    name: 'manageClose',
    component: ManageClose
  },
  
  {
    path: '/manage-warrants-without-settlements/',
    name: 'manageWarrantsWithoutSettlements',
    component: ManageWarrantsWithoutSettlements
  },
  {
    path: '/manage-settlements-in-default/',
    name: 'manageSettlementsInDefault',
    component: ManageSettlementsInDefault
  },
  {
    path: '/manage-warrants-3-reminders/',
    name: 'manageWarrants3Reminders',
    component: ManageWarrants3Reminders
  },
  {
    path: '/manage-warrants-stopped/',
    name: 'manageWarrantsStopped',
    component: ManageWarrantsStopped
  },
 
  {
    path: '/manage-unused/',
    name: 'manageUnused',
    component: ManageUnused
  },
  
  {
    path: '/warrants/:search',
    name: 'warrantsSearch',
    component: Warrants
  },
  {
    path: '/account-statements',
    name: 'account-statements',
    component: AccountStatements
  },
  {
    path: '/account-statement/view/:id',
    name: 'accountStatementView',
    component: AccountStatementView
  },
 
  { path: '*', redirect: 'warrants' }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
